import React, { useEffect, useState } from "react";
import useEventData from "../../custom_hooks/useEventData";
import { eventDataType } from "./type/celebrations.types";
import DataLoading from "../../common/loading-data";
import CelebrationsView from '../../page-components/celebrations/celebrations.view';
import { mapApiRecord } from "../../utility/event.utils";

const CelebrationPage = () => {
    const {data: {birthdays, workAnniversaries}} = useEventData();

    const [newBirthdayData, setNewBirthdayData] = useState<eventDataType>({
        today: [],
        passed: [],
        upcoming: []
    });
    const [newAnniversaryData, setNewAnniversaryData] = useState<eventDataType>({
        today: [],
        passed: [],
        upcoming: []
    });

    useEffect(() => {
        onInit();
    }, [birthdays, workAnniversaries]);

    const setData = (data: any) => {
        const val = mapApiRecord(data);
        return val;
    }

    const onInit = () => {
        if (birthdays) {
            const data = setData(birthdays);
            setNewBirthdayData(data);
        }
        if (workAnniversaries) {
            const data = setData(workAnniversaries);
            setNewAnniversaryData(data);
        }
    };

    return (
        !newBirthdayData && !newAnniversaryData ?
            (
                <DataLoading title="Team Celebrations"/>
            ) :
            (
                <CelebrationsView newBirthdayData={newBirthdayData} newAnniversaryData={newAnniversaryData}/>
            )

    )
}

export default CelebrationPage;
